import ChatbotWidget from "./ChatbotWidget";
import { AuthProvider } from "./AuthProvider"; // import your context provider

function App() {
  return (
    <AuthProvider>
      <div className="App">
        <ChatbotWidget />
      </div>
    </AuthProvider>
  );
}

export default App;
